angular.module('CaresApp').factory('RoleChangeAlertService', function($resource) {
    return $resource('api/roleChangeAlerts', {
    }, {
    'update': {
      method: 'PUT',
    }
    });
  });
